import OrganizationTab from './OrganizationTab'
export default OrganizationTab


// WEBPACK FOOTER //
// ./src/components/ChannelTabs/DobovoTab/MappingTabs/OrganizationTab/index.js